import { type ConciergeTierInfo } from '@rtkwlf/track-public';

export const DEFAULT_ORG_TIER = {
  tier: '1',
  legacy: true,
} satisfies ConciergeTierInfo;
